import { render, staticRenderFns } from "./SuperAdmin.vue?vue&type=template&id=3b08f593"
import script from "./SuperAdmin.vue?vue&type=script&lang=js"
export * from "./SuperAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports